<template>
    <nav class="home-navigation flex flex-row md:flex-col justify-center md:justify-start items-center md:items-start">
        <div ref="dot" v-for="(casestudy, index) in casestudies" :key="index" :class="['bg-' + headerColor, { 'w-1 h-1': currentIndex === index, 'w-2 h-2': currentIndex != index}]" class="home-navigation__dot ml-3 md:ml-0 md:mt-3 rounded cursor-pointer" @click.prevent="$emit('DOTCLICKED', index)"></div>
    </nav>
</template>

<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import { TweenMax, Power3 } from 'gsap';

    export default {
        props : {
            casestudies : {
                type : Array,
                default : () => {}
            },
            currentIndex : {
                type : Number,
                default : 0
            }
        },

        computed : {
            ...mapState([
                'headerColor'
            ])
        },

        watch : {
            currentIndex(){
                // console.log(this.$refs.dot);

                this.updateDots();
            }
        },

        mounted(){
            this.updateDots();
        },

        methods : {
            updateDots(){
                Vue.nextTick(() => {
                    TweenMax.to(this.$refs.dot, 0.5, {
                        width : 8,
                        height : 8,
                        x : 0,
                        y : 0,
                        ease : Power3.easeOut
                    });

                    TweenMax.to(this.$refs.dot[this.currentIndex], 0.5, {
                        width : 4,
                        height : 4,
                        x : (window.innerWidth < 768) ? 0 : 2,
                        ease : Power3.easeOut
                    });

                });
            }
        }
    }
</script>

<style lang="scss">
    .home-navigation__dot {
        &:first-child {
            transform : translateX(2px);
        }
    }
</style>